import isNil from 'lodash-es/isNil';
import { BillingStatus, OrgRole } from '../../enums';
import { or, plotOrOrganizationRoleBearerRule } from './ruleHelpers';
const upcaseFirst = (x) => x.charAt(0).toUpperCase() + x.slice(1);
export const isRole = (label) => plotOrOrganizationRoleBearerRule(`is${upcaseFirst(label)}`, (subject, op, object, { roleBearer }) => !isNil(roleBearer?.myRole) && roleBearer?.myRole === OrgRole[label]);
export const isOneOfRoles = (labels) => plotOrOrganizationRoleBearerRule(`is${labels.map(upcaseFirst).join('Or')}`, (subject, op, object, { roleBearer }) => {
    const labelsId = labels.map((l) => OrgRole[l]);
    return labelsId.includes(roleBearer?.myRole);
});
export const isAdmin = isRole('admin');
export const isOwner = isRole('owner');
export const isAgent = isRole('agent');
export const isAdvizor = isRole('advisor');
export const isViewer = isRole('viewer');
export const isMe = (subject, op, object, { myEmail, email }) => myEmail === email;
export const isNetwork = (subject, op, object, { organization }) => {
    return !isNil(organization.networkType);
};
export const isDeviceFromOwnOrganization = (subject, op, object, { device }) => device.origin === 'own';
export const isPlotArchived = (subject, op, object, { plot }) => plot.archived;
export const deny = () => false;
export const isAdminOrOwner = or(isAdmin, isOwner);
export const isAdminOwnerOrAdvizor = or(isAdminOrOwner, isAdvizor);
export const isAdminOwnerOrAgent = or(isAdminOrOwner, isAgent);
export const isAdminOwnerAgentOrAdvizor = or(isAdminOwnerOrAgent, isAdvizor);
export const isAdminOwnerAgentOrViewer = or(isAdminOwnerOrAgent, isViewer);
export const isAdminOwnerAgentAdvizorOrViewer = or(isAdminOwnerAgentOrViewer, isAdvizor);
export const isOrganizationPremium = (subject, op, object, { organization }) => organization.billingStatus === BillingStatus.plus ||
    organization.billingStatus === BillingStatus.expert;
export const isSuperuser = (subject, op, object, { account }) => account.isSuperuser;
export const isStaff = (subject, op, object, { account }) => account.isStaff;
export const isStaffOrSuperuser = or(isStaff, isSuperuser);
export const isOptionFreemium = (subject, op, object, { option }) => option.code === 'OAD-WEEPHYT';
export const isOptionFreemiumOrOrganizationPremium = or(isOptionFreemium, isOrganizationPremium);
